import React from "react";
import {createRoot} from "react-dom/client";
import App from "./App";

document.body.classList.remove('dark-theme');
document.documentElement.classList.add('light-theme');

const root = createRoot(document.getElementById("root"))
root.render(<App />);

// Remove the call to initializeSchema